export default __webpack_public_path__ + "static/media/chinese.msyh.554cdb5e.ttf";